module.exports = __webpack_public_path__ + "static/media/defaultCompany.48a6a941.png";